import React from 'react';
import styled from 'styled-components';
import Icon from '@etiquette-ui/icons';
import { BaseDialog as Dialog } from '@etiquette-ui/alert-dialog';
import './styles.css'

const CustomDialog = styled(Dialog)`
  .dialog-module_content__2NnHL {
    background-color: transparent;
  }
`;

const DialogCloseButton = styled.div`
  padding: 0px;
  position: absolute;
  right: -4px;
  top: -30px;
`;

const Body = styled.div`
  max-width: 35vh;
  margin: -45px -25px -50px;
  background-color: white;  
`;

const BaseDialog = ({children, onClose, ...rest})=>{
  const {
    contentStyle = {},
    overlayStyle = {},
    style = {borderRadius: '0px 0px 4px 4px'},
    ...restProps
  } = rest;

  return (
    <CustomDialog 
      showCloseButton={false}
      modalProps={{
        onRequestClose: onClose,
        closeTimeoutMS: 200,
        style: {
          content: {
            border: 'none',
            maxWidth: '35vh',
            borderRadius: '0px',
            overflow: 'visible',
            backgroundColor: 'transparent',
            ...contentStyle
          },
          overlay: {
            backgroundColor:'rgba(0,0,0,.5)',
            zIndex: '1000',
            ...overlayStyle
          }
        },
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEsc: true,
        shouldReturnFocusAfterClose: false
      }}
      {...restProps}
    >
      <Body style={style}>
        <DialogCloseButton onClick={onClose}>
          <Icon
            icon={'wrong'}
            styles={{
              svg: {
                width: '25px',
                height: '25px',
              },
              line: {
                fill: 'none',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '1.5px',
                stroke: 'white',
              },
            }}
          />
        </DialogCloseButton>
        {children}
      </Body>      
    </CustomDialog>
  );
}
export default BaseDialog;